export default "__VITE_ASSET__D5Ns6cJE__"